<app-popup [isVisible]="true">
  <h4 header>
    <span class="font-weight-normal"> {{ 'refund.modal.title' | translate }}</span>
  </h4>

  <div class="row">
    <div class="col-12">
      <div class="question">
        <span>
          {{
            'refund.modal.select_first_line'
              | translate
                : {
                    count: content.items.length,
                    plural_text: 'pluralMapper.ticket' | translateSelector : { count: content.items.length }
                  }
          }}
        </span>
        <br />
        <span *ngIf="hasRefundableItems">
          <b>{{ 'refund.modal.select_second_line' | translate }}</b>
        </span>
      </div>
    </div>
    <div class="col-12 p-3">
      <div *ngIf="hasRefundableItems" class="form-group align-content-center mb-3">
        <div class="checkbox">
          <label [for]="checkAllModel.id" class="d-flex align-content-center">
            <input type="checkbox" class="form-checkbox form-radio" [id]="checkAllModel.id"
                   [(ngModel)]="checkAllModel.checked" (change)="checkAll()" />
            <span [className]="checkAllModel.checked ? 'checkbox-active cr' : 'cr'"><i
                 class="cr-icon fa fa-check"></i></span><span><b>{{ 'shared.checkAll' | translate }}</b></span>
          </label>
        </div>
      </div>
      <ng-container *ngFor="let item of content.items; let last = last">
        <div class="form-group align-content-center" [ngClass]="{'mb-0': last}">
          <ng-container *ngIf="item.content.isRefundable; else noRefundableTemplate">
            <div class="checkbox">
              <label [for]="item.id" class="d-flex align-content-center">
                <input type="checkbox" class="form-checkbox form-radio" [id]="item.id" [(ngModel)]="item.checked"
                       (ngModelChange)="checkGroup(item)" />
                <span [class]="item.checked ? 'checkbox-active cr' : 'cr'">
                  <i class="cr-icon fa fa-check"></i>
                </span>
                <ng-container *ngTemplateOutlet="label"></ng-container>
              </label>
            </div>
          </ng-container>

          <ng-template #noRefundableTemplate>
            <div class="checkbox">
              <label class="cursor-default">
                <span class="cr cr-none"></span>
                <ng-container *ngTemplateOutlet="label"></ng-container>
              </label>
            </div>
          </ng-template>

          <ng-template #label>
            <div class="d-flex align-items-center justify-content-between w-100 gap-05">
              <span class="text-start">{{ item.name }}</span>
              <span *ngIf="item.innerContent" [innerHtml]="item.innerContent"
                    class="inner-content text-end text-nowrap"></span>
            </div>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="row" footer>
    <div class="col-12 text-center d-flex justify-content-center gap-2 flex-wrap">
      <button type="button" class="btn btn-default" (click)="close()">
        {{ 'refund.modal.button.decline' | translate }}
      </button>
      <button *ngIf="hasRefundableItems" type="button" class="btn btn-next" (click)="accept()"
              [disabled]="acceptDisabled">
        {{ 'refund.modal.button.confirm' | translate }}
      </button>
    </div>
  </div>
</app-popup>